export interface SearchResponse {
  hits: SearchHit[];
  page: number;
  nbHits: number;
  nbPages: number;
  hitsPerPage: number;
}

export interface SearchHit {
  objectID: string;
  title: string;
  excerpt: string;
  uri: string;
}

const SEARCH_WORKER_URL = process.env.NEXT_PUBLIC_SEARCH_WORKER_URL;

export async function search(query: string): Promise<SearchResponse> {
  if (!SEARCH_WORKER_URL) {
    throw new Error('Search worker URL is not configured');
  }

  const response = await fetch(
    `${SEARCH_WORKER_URL}/search?q=${encodeURIComponent(query)}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error('検索中にエラーが発生しました');
  }

  return response.json();
}
